import React from "react";
import {
  CircularProgress,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { formatTimestamp, formatFileSize } from "../../utils";
import DocumentThumbnail from "./DocumentThumbnail";
import s from "../MerchantDocumentUpload.module.scss";
import c from "lib/style/colorVar.scss";

const FilesCell = ({
  row,
  deletingFileId,
  onDeleteRequest,
  onOpenPreview,
}) => {
  if (!row.files?.length) {
    return (
      <Typography variant="body2" className={s.emptyCell}>
        {"-"}
      </Typography>
    );
  }

  return (
    <Stack className={s.filesCell} gap={1} >
      {row.files.map((file, index) => {
        const isDeleting = deletingFileId === file.id;
        const hasDownload = !!file.url;
        return (
          <Stack
            key={`${row.id}-${file.id}`}
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
            className={s.fileRow}
            gap={1}
          >
            <Stack
              direction="row"
              alignItems="center"
              className={s.fileInfo}
              gap={1}
              onClick={() => {
                if (hasDownload) {
                  onOpenPreview(row.id, index);
                }
              }}
              sx={{ cursor: hasDownload ? "pointer" : "default" }}
            >
              <DocumentThumbnail document={file} />
              <Stack 
                direction="column" 
                alignItems="flex-start" 
                gap={0.25}
                sx={{ 
                  minWidth: 0, 
                  flex: 1, 
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "100%"
                }}
              >
                {hasDownload ? (
                  <a
                    href={file.url}
                    target="_blank"
                    rel="noreferrer"
                    className={s.fileName}
                    onClick={(event) => {
                      event.preventDefault();
                      onOpenPreview(row.id, index);
                    }}
                  >
                    {file.name}
                  </a>
                ) : (
                  <span className={s.fileName}>{file.name}</span>
                )}
                <Typography variant="caption" className={s.fileMeta}>
                  {[
                    (() => {
                      const ts = formatTimestamp(file.created);
                      return ts === "-" ? null : ts;
                    })(),
                    file.size ? formatFileSize(file.size) : null,
                  ]
                    .filter(Boolean)
                    .join(" · ")}
                </Typography>
              </Stack>
            </Stack>
            <IconButton
              size="small"
              onClick={() => onDeleteRequest(file)}
              disabled={isDeleting}
            >
              {isDeleting ? (
                  <CircularProgress 
                    size={16} 
                    sx={{ color: c.brandDark12 }}
                  />
              ) : (
                <DeleteOutlineIcon fontSize="small" />
              )}
            </IconButton>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default FilesCell;
